var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvgLengthofStay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F8B00E",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_2154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 14H14V35H35V14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.127 21.793C18.6739 21.793 18.3066 22.1602 18.3066 22.6133C18.3066 23.0663 18.6739 23.4336 19.127 23.4336C19.58 23.4336 19.9473 23.0663 19.9473 22.6133C19.9473 22.1602 19.58 21.793 19.127 21.793Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6953 21.793C22.2423 21.793 21.875 22.1602 21.875 22.6133C21.875 23.0663 22.2423 23.4336 22.6953 23.4336C23.1484 23.4336 23.5156 23.0663 23.5156 22.6133C23.5156 22.1602 23.1484 21.793 22.6953 21.793Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2637 21.793C25.8106 21.793 25.4434 22.1602 25.4434 22.6133C25.4434 23.0663 25.8106 23.4336 26.2637 23.4336C26.7167 23.4336 27.084 23.0663 27.084 22.6133C27.084 22.1602 26.7167 21.793 26.2637 21.793Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.832 21.793C29.379 21.793 29.0117 22.1602 29.0117 22.6133C29.0117 23.0663 29.379 23.4336 29.832 23.4336C30.2851 23.4336 30.6523 23.0663 30.6523 22.6133C30.6523 22.1602 30.2851 21.793 29.832 21.793Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9473 26.1816C19.9473 25.7286 19.58 25.3613 19.127 25.3613C18.6739 25.3613 18.3066 25.7286 18.3066 26.1816C18.3066 26.6347 18.6739 27.002 19.127 27.002C19.58 27.002 19.9473 26.6347 19.9473 26.1816Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9473 29.75C19.9473 29.2969 19.58 28.9297 19.127 28.9297C18.6739 28.9297 18.3066 29.2969 18.3066 29.75C18.3066 30.2031 18.6739 30.5703 19.127 30.5703C19.58 30.5703 19.9473 30.2031 19.9473 29.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5156 26.1816C23.5156 25.7286 23.1484 25.3613 22.6953 25.3613C22.2423 25.3613 21.875 25.7286 21.875 26.1816C21.875 26.6347 22.2423 27.002 22.6953 27.002C23.1484 27.002 23.5156 26.6347 23.5156 26.1816Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5156 29.75C23.5156 29.2969 23.1484 28.9297 22.6953 28.9297C22.2423 28.9297 21.875 29.2969 21.875 29.75C21.875 30.2031 22.2423 30.5703 22.6953 30.5703C23.1484 30.5703 23.5156 30.2031 23.5156 29.75Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6953 21.793C22.2423 21.793 21.875 22.1602 21.875 22.6133C21.875 23.0663 22.2423 23.4336 22.6953 23.4336C23.1484 23.4336 23.5156 23.0663 23.5156 22.6133C23.5156 22.1602 23.1484 21.793 22.6953 21.793Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5156 26.1816C23.5156 25.7286 23.1484 25.3613 22.6953 25.3613C22.2423 25.3613 21.875 25.7286 21.875 26.1816C21.875 26.6347 22.2423 27.002 22.6953 27.002C23.1484 27.002 23.5156 26.6347 23.5156 26.1816Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5156 29.75C23.5156 29.2969 23.1484 28.9297 22.6953 28.9297C22.2423 28.9297 21.875 29.2969 21.875 29.75C21.875 30.2031 22.2423 30.5703 22.6953 30.5703C23.1484 30.5703 23.5156 30.2031 23.5156 29.75Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2867 27.0019H29.1233C28.9475 27.0019 28.7917 26.9333 28.7373 26.7668L28.3721 25.6405C28.3114 25.4544 28.1488 25.3613 27.9861 25.3613C27.8235 25.3613 27.6609 25.4544 27.6001 25.6405L27.2349 26.7668C27.1806 26.9333 27.0248 27.0019 26.8489 27.0019H25.6872C25.294 27.0019 25.1306 27.547 25.4487 27.7771L26.3847 28.4687C26.5269 28.5716 26.5864 28.754 26.5321 28.9204L26.1669 30.0395C26.0454 30.4118 26.4734 30.7214 26.7915 30.4913L27.7476 29.7995C27.8187 29.7481 27.9024 29.7223 27.9861 29.7223C28.0698 29.7223 28.1536 29.7481 28.2247 29.7995L29.1808 30.4913C29.4989 30.7214 29.9269 30.4118 29.8053 30.0395L29.4402 28.9204C29.3858 28.754 29.4453 28.5716 29.5876 28.4687L30.5252 27.7771C30.8434 27.547 30.6799 27.0019 30.2867 27.0019Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_2154)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_122_2154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 21,
    height: 21
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H35V35H14V14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_122_2154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1797 31.7188C34.1797 33.0779 33.0779 34.1797 31.7187 34.1797H17.2812C15.9221 34.1797 14.8203 33.0779 14.8203 31.7188V18.9219C14.8203 17.5627 15.9221 16.4609 17.2812 16.4609H31.7187C33.0779 16.4609 34.1797 17.5627 34.1797 18.9219V27.6172",
    stroke: "#ED8302",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.127 14.8203V18.1016",
    stroke: "#ED8302",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.832 18.1016V14.8203",
    stroke: "#ED8302",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.459 14.8203V18.1016",
    stroke: "#ED8302",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4742 25.2047H28.9697C28.7423 25.2047 28.5408 25.1125 28.4705 24.8888L27.9982 23.3752C27.9196 23.1251 27.7093 23 27.499 23C27.2887 23 27.0784 23.1251 26.9998 23.3752L26.5275 24.8888C26.4573 25.1125 26.2557 25.2047 26.0283 25.2047H24.526C24.0175 25.2047 23.8061 25.9372 24.2174 26.2463L25.4279 27.1757C25.6119 27.314 25.6888 27.5591 25.6186 27.7829L25.1463 29.2867C24.9892 29.787 25.5427 30.203 25.9541 29.8938L27.1905 28.9641C27.2825 28.895 27.3907 28.8605 27.499 28.8605C27.6072 28.8605 27.7156 28.895 27.8075 28.9641L29.044 29.8938C29.4553 30.203 30.0088 29.787 29.8517 29.2867L29.3794 27.7829C29.3091 27.5591 29.3861 27.314 29.5701 27.1757L30.7827 26.2463C31.1941 25.9372 30.9826 25.2047 30.4742 25.2047Z",
    fill: "#ED8302"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgLengthofStay);
export default __webpack_public_path__ + "static/media/Avg Length of Stay.92f3073c949bcf9d6bb4774c1eafef8c.svg";
export { ForwardRef as ReactComponent };